<template>
  <footer class="footer footer-black footer-white d-none d-lg-block">
    <div class="container-fluid">
      <div class="row">
        <nav class="footer-nav">
          <ul>
            <li>
              <a href="https://cabcard.services">CabCard Services</a>
            </li>
            <li>
              <a href="https://cabcard.services/support">Support</a>
            </li>
          </ul>
        </nav>
        <div class="credits ml-auto">
          <div class="copyright pull-right">
            &copy; {{ year }} Magnus 1265 Ltd |
            <span>v2309131457</span>
          </div>
        </div>
        <payment-services-statement
          class="col-12"
        ></payment-services-statement>
      </div>
    </div>
  </footer>
</template>
<script>
import PaymentServicesStatement from "src/components/UIComponents/PaymentServicesStatement.vue";

export default {
  name: "main-footer",
  components: {
    PaymentServicesStatement,
  },
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style></style>
